import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Damage extends Bloc {

	constructor (src, ctx) {

		super("damage", src, ctx, true);
		this.f = (src, ins) => {
			if (ins[0]?.removedFromFight || (ins[0]?.id?.type === "enemy" && ins[0]?.dead && ins[0]?.removed))
				return [0, true, 0, 0];

			let damage = ins[2];

			// Double strike damage with amulet
        	if (src.master.run.champion.getPassive("strikedefendmultiplier") && src.model && (src.model.originalName || src.model.name) === "Strike")
            	damage *= src.master.run.champion.getPassive("strikedefendmultiplier");

            let output = ins[3] === false ? damage : ins[0].modifyDamageIn(damage, ins[1], src);
			let result = ins[0].damage(output, ins[1], ins[3] !== false);
			return [result.dmg, ins[0].dead, 0, output];
		};
		this.types = [Types.entity, Types.entity, Types.int, Types.bool];
	}
}
